/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CatalogCreateCatalogResponse } from "./CatalogCreateCatalogResponse";

export type CatalogCreateCatalogResponseApiRespoonse = {
  data?: CatalogCreateCatalogResponse;
  status?: CatalogCreateCatalogResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace CatalogCreateCatalogResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
